/*
  Levée round 7c (2026-10-16): quick add on the collection page and the style pages (sections/levee-collection.liquid).
  A card's bag opens one size sheet with no size chosen: EU sizes (sold-out sizes disabled and marked), the Size Chart
  opening in place, the style's fit line, Add to cart muted until a size is tapped. Adding stays on the page: the pair
  goes in with /cart/add and the theme's own cart-update event re-renders and opens the cart drawer (its Buy 2 Get 1 Free
  progress copy is the drawer's own). Esc and the dim close the sheet; focus stays inside it and returns to the bag.
  Add-to-cart pattern: the same as Complete the look (assets/levee-pdp-v2.js, initCompleteLook, round 6b/7b).
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-lvc]');
  if (!root || root.__lvc) return;
  root.__lvc = true;

  var sheet = root.querySelector('[data-lvc-sheet]');
  if (!sheet) return;
  var panel = sheet.querySelector('[data-lvc-panel]');
  var nameEl = sheet.querySelector('[data-lvc-sheet-name]');
  var priceEl = sheet.querySelector('[data-lvc-sheet-price]');
  var thumb = sheet.querySelector('[data-lvc-thumb]');
  var sizesEl = sheet.querySelector('[data-lvc-sizes]');
  var fitEl = sheet.querySelector('[data-lvc-fit]');
  var add = sheet.querySelector('[data-lvc-add]');
  var addPrices = sheet.querySelector('[data-lvc-add-prices]');
  var errEl = sheet.querySelector('[data-lvc-error]');
  var live = sheet.querySelector('[data-lvc-live]');
  var chart = sheet.querySelector('[data-lvc-chart]');
  var chartBody = sheet.querySelector('[data-lvc-chart-body]');
  var chartOpen = sheet.querySelector('[data-lvc-chart-open]');

  var current = null;   // the tapped card's data
  var opener = null;    // the bag that opened the sheet
  var size = '';
  var busy = false;
  var uid = 0;

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function variantFor(sz) { return (current && current.variants || []).filter(function (v) { return v.size === sz; })[0] || null; }

  function priceHtml(v) {
    if (!v) return '';
    return (v.compare ? '<s class="lvc-card__was"><span class="visually-hidden">Regular price </span>' + esc(v.compare) + '</s>' : '') +
      '<span class="lvc-card__now"><span class="visually-hidden">' + (v.compare ? 'Sale price ' : 'Price ') + '</span>' + esc(v.price) + '</span>';
  }

  function render() {
    var v = size ? variantFor(size) : null;
    var shown = v || (current.variants || []).filter(function (x) { return x.available; })[0] || current.variants[0];
    priceEl.innerHTML = priceHtml(shown);
    addPrices.innerHTML = shown ? ((shown.compare ? '<s><span class="visually-hidden">Regular price </span>' + esc(shown.compare) + '</s>' : '') + '<span>' + esc(shown.price) + '</span>') : '';
    if (!busy) add.disabled = !(v && v.available);
    add.setAttribute('aria-label', 'Add to cart: ' + current.title + (size ? ', size ' + size : '') + (shown ? ', ' + shown.price : ''));
  }

  function buildSizes() {
    uid += 1;
    var name = 'lvc-size-' + uid;
    sizesEl.innerHTML = (current.variants || []).map(function (v, i) {
      var id = name + '-' + i;
      return '<span class="lvc-size" data-lvc-size>' +
        '<input type="radio" name="' + name + '" id="' + id + '" value="' + esc(v.size) + '"' + (v.available ? '' : ' disabled') +
        ' aria-label="' + esc(v.size) + (v.au ? ', AU ' + esc(v.au) : '') + (v.available ? '' : ', sold out') + '">' +
        // Round 7f: the Australian size under the EU size (v.au from snippets/levee-au-size.liquid via levee-card)
        '<label for="' + id + '" aria-hidden="true">' + (v.au ? '<span class="lvc-eu">' + esc(v.size) + '</span><span class="lvc-au">AU ' + esc(v.au) + '</span>' : esc(v.size)) + '</label></span>';
    }).join('');
  }

  function focusables() {
    var box = sheet.querySelector('.lvc-sheet__panel.is-chart') ? chart : panel;
    return [].slice.call(box.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; })
      // radios: only the checked one (or the first enabled when none is checked) is a tab stop
      .filter(function (el) {
        if (el.type !== 'radio') return true;
        var group = sizesEl.querySelectorAll('input[type=radio]:not([disabled])');
        var checked = sizesEl.querySelector('input[type=radio]:checked');
        return checked ? el === checked : el === group[0];
      });
  }

  function openSheet(card, bag) {
    var data;
    try { data = JSON.parse(card.querySelector('[data-lvc-data]').textContent); } catch (e) { return; }
    if (!data || !data.variants || !data.variants.length) return;
    current = data;
    opener = bag;
    size = '';
    busy = false;
    errEl.hidden = true;
    errEl.textContent = '';
    live.textContent = '';
    nameEl.textContent = data.title;
    fitEl.textContent = data.fit || '';
    if (data.img) { thumb.src = data.img; thumb.alt = ''; }
    buildSizes();
    closeChart(true);
    chartOpen.hidden = !chartTemplate();
    render();
    sheet.hidden = false;
    document.documentElement.classList.add('lvc-lock');
    panel.focus({ preventScroll: true });
  }

  function closeSheet() {
    if (sheet.hidden) return;
    sheet.hidden = true;
    document.documentElement.classList.remove('lvc-lock');
    closeChart(true);
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
  }

  function chartTemplate() {
    if (!current) return null;
    return (current.chart && sheet.querySelector('[data-lvc-chart-tpl="' + current.chart + '"]')) || sheet.querySelector('[data-lvc-chart-tpl]');
  }

  function openChart() {
    var tpl = chartTemplate();
    if (!tpl) return;
    chartBody.innerHTML = '';
    chartBody.appendChild(tpl.content.cloneNode(true));
    chart.hidden = false;
    panel.classList.add('is-chart');
    panel.scrollTop = 0;
    chart.focus({ preventScroll: true });
  }

  function closeChart(quiet) {
    if (chart.hidden) return;
    chart.hidden = true;
    panel.classList.remove('is-chart');
    if (!quiet) chartOpen.focus({ preventScroll: true });
  }

  function addToCart() {
    var v = size ? variantFor(size) : null;
    if (busy || !v || !v.available) return;
    var settings = window.FoxThemeSettings || {};
    var routes = settings.routes || {};
    var body = new FormData();
    body.append('id', v.id);
    body.append('quantity', '1');
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.getSectionsToRender) sections = sections.concat(drawer.getSectionsToRender().map(function (s) { return s.id; }));
    var mainCart = document.querySelector('cart-items');
    if (mainCart && mainCart.getSectionsToRender) sections = sections.concat(mainCart.getSectionsToRender().map(function (s) { return s.section; }));
    if (sections.length) {
      body.append('sections', sections);
      body.append('sections_url', window.location.pathname);
    }
    busy = true;
    add.disabled = true;
    add.setAttribute('aria-busy', 'true');
    errEl.hidden = true;
    live.textContent = 'Adding to your cart';
    var queue = window.FoxThemeCartMutations;
    var work = function () {
      return fetch(routes.cart_add_url || '/cart/add', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state.status) throw new Error(state.description || state.message || 'This pair could not be added.');
          busy = false;
          add.removeAttribute('aria-busy');
          live.textContent = 'Added to your cart';
          closeSheet();
          var ev = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
          if (window.FoxThemeEvents && state.sections) window.FoxThemeEvents.emit(ev, state);
          else window.location.assign(routes.cart_url || '/cart');
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: state } }));
        });
    };
    if (queue && queue.flushQuantityChanges) queue.flushQuantityChanges();
    (queue ? queue.enqueue(work) : work())
      .catch(function (e) {
        busy = false;
        add.removeAttribute('aria-busy');
        errEl.textContent = e.message;
        errEl.hidden = false;
        live.textContent = '';
        render();
      });
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    var bag = t.closest && t.closest('[data-lvc-bag]');
    if (bag && root.contains(bag)) {
      e.preventDefault();
      openSheet(bag.closest('[data-lvc-card]'), bag);
      return;
    }
    if (t.closest && t.closest('[data-lvc-close]')) { closeSheet(); return; }
    if (t.closest && t.closest('[data-lvc-chart-open]')) { openChart(); return; }
    if (t.closest && t.closest('[data-lvc-chart-close]')) { closeChart(false); return; }
    if (t.closest && t.closest('[data-lvc-add]')) { addToCart(); }
  });

  sizesEl.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    size = t.value;
    errEl.hidden = true;
    render();
  });

  sheet.addEventListener('keydown', function (e) {
    if (sheet.hidden) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      if (!chart.hidden) closeChart(false); else closeSheet();
      return;
    }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) { e.preventDefault(); return; }
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || active === panel || active === chart)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    else if (list.indexOf(active) === -1 && active !== panel && active !== chart) { e.preventDefault(); first.focus(); }
  });
})();

/*
  Round 8a (2026-10-17, Round 8 checklist C4 and C5): the reviews band keeps going, like the product page's "Loved by real
  women" carousel. After the six hand-cropped cards (snippets/levee-collection-reviews.liquid) it adds every other genuine
  customer photo review from Loox's Storefront API (one store-wide read of the 5-star reviews, the same read and the same
  screen as assets/levee-pdp-v2.js): verified, five stars, dated from 30 Oct 2025, not Natalia C. (Talia, a paid creator),
  not a text repeated under another name, no health word, no rival brand, "leather" only as "vegan leather", photos only
  (no videos). Each photo sits beside its own reviewer's words and name, centred in its 4:5 frame. On a style page the
  style's own reviews come first, then the rest, newest first. Card shells go in at once; each photo loads when its card
  comes within about two cards of the screen. If Loox can't be reached the six cards stay as they are.
*/
(function () {
  'use strict';
  var band = document.querySelector('[data-lvc-reviews][data-store-id]');
  if (!band || band.__lvr) return;
  band.__lvr = true;
  var track = band.querySelector('.lvc-reviews__track');
  var storeId = band.getAttribute('data-store-id');
  var style = band.getAttribute('data-style') || '';
  if (!track || !storeId) return;
  var API = 'https://storefront-api.loox.io/storefront/v1/store/';
  var FROM = Date.parse('2025-10-30T00:00:00+10:00');
  var HEALTH = /\b(?:heal|healed|healing|relief|pain|painful|sore|ache|aches|aching|hurt|hurts|plantar|fasciitis|bunion|bunions|arthritis|orthotic|podiatrist|neuropathy|surgery|injury|cure|cured)\b/i;
  var RIVAL = /birkenstock|birks|brooks|kumi|ziera|frankie4|vionic|skechers|slyde|oofos|crocs/i;
  var DENY = (band.getAttribute('data-deny') || '').split(',').filter(Boolean);
  // Loox product id (review.product.id) to style, as in assets/levee-pdp-v2.js (read from Loox 17 Oct 2026).
  var STYLE_OF = {
    '8979903086846': 'signature', '8958943166718': 'signature', '9131324834046': 'signature', '9180504129790': 'signature',
    '8981440299262': 'signature', '8959335366910': 'signature', '9131324997886': 'signature',
    '8981440233726': 'signature', '8959223693566': 'signature', '9131324866814': 'signature',
    '8974589231358': 'signature', '8979886833918': 'signature', '8979903906046': 'signature',
    '9138674368766': 'buckled', '9138675286270': 'buckled',
    '9138673352958': 'double-strap', '9138673582334': 'double-strap', '9138673811710': 'double-strap',
    '9138668241150': 'denim', '9138669388030': 'denim', '9138669486334': 'denim'
  };
  var shown = {};
  [].forEach.call(track.querySelectorAll('[data-review-id]'), function (f) { shown[f.getAttribute('data-review-id')] = 1; });
  var tpl = track.querySelector('.lvc-review');
  var heartsHtml = tpl ? (tpl.querySelector('.lvc-review__hearts') || {}).outerHTML || '' : '';

  function text(s) {
    return String(s || '')
      .replace(/(^|[^*_])(\*\*\*|___|\*\*|__)(?=[^\s*_])([\s\S]*?[^\s*_])\2(?![*_])/g, '$1$3')
      .replace(/(^|[\s(\["'“‘])([*_])(?=[^\s*_])([^*_\n]*?[^\s*_])\2(?=$|[\s)\]"'”’.,!?;:])/g, '$1$3')
      .trim();
  }
  function photoOf(r) {
    var list = Array.isArray(r && r.media) ? r.media : [];
    for (var i = 0; i < list.length; i++) if (list[i] && list[i].type === 'photo' && list[i].url) return list[i];
    return null;
  }
  function hasVideo(r) {
    var list = Array.isArray(r && r.media) ? r.media : [];
    return list.some(function (m) { return m && m.type === 'video'; });
  }
  function plain(url) { return /images\.loox\.io\//.test(url) ? url.replace(/_orig(\.[a-z]+)$/i, '$1') : url; }
  function mid(url) { return /images\.loox\.io\//.test(url) ? url.replace(/_orig(\.[a-z]+)$/i, '_mid$1') : url; }
  function ts(r) { return Date.parse(r.date || r.createdAt) || 0; }
  function ok(r) {
    if (!r || r.rating !== 5 || r.verified !== true || shown[r.id] || DENY.indexOf(r.id) !== -1) return false;
    var body = String(r.body || '').trim();
    var name = String(r.reviewer && r.reviewer.name || '').trim();
    if (!body || !text(body) || !name || name.toLowerCase() === 'natalia c.') return false;
    if (HEALTH.test(body) || RIVAL.test(body)) return false;
    if (/leather/i.test(body.replace(/vegan[\s-]+leather/gi, ''))) return false;
    if (!(ts(r) >= FROM)) return false;
    return !!photoOf(r) && !hasVideo(r);
  }
  function stamp() { return new Date(Date.now() + 10 * 3600 * 1000).toISOString().slice(0, 10).replace(/-/g, ''); }
  function read(page, acc) {
    var url = new URL(API + encodeURIComponent(storeId) + '/product-reviews');
    url.searchParams.set('rating', 5); url.searchParams.set('sort', 'featured'); url.searchParams.set('limit', 100);
    if (page > 1) url.searchParams.set('page', page);
    url.searchParams.set('v', stamp());
    return fetch(url.toString(), { mode: 'cors', credentials: 'omit' }).then(function (res) {
      if (!res.ok) throw new Error('Loox ' + res.status);
      return res.json();
    }).then(function (d) {
      var list = (d && d.reviews) || [];
      acc = acc.concat(list);
      var last = list[list.length - 1];
      if (d && d.pagination && d.pagination.hasMore && last && Array.isArray(last.media) && last.media.length && page < 20) return read(page + 1, acc);
      return acc;
    });
  }
  function card(r) {
    var photo = photoOf(r);
    var name = String(r.reviewer.name).trim();
    var fig = document.createElement('figure');
    fig.className = 'lvc-review lvc-review--more';
    fig.setAttribute('role', 'listitem');
    fig.setAttribute('data-review-id', r.id);
    var img = document.createElement('img');
    img.className = 'lvc-review__photo';
    img.width = 236; img.height = 295; img.decoding = 'async';
    img.alt = 'Customer photo from ' + name;
    var cap = document.createElement('figcaption');
    cap.className = 'lvc-review__body';
    cap.innerHTML = heartsHtml;
    var q = document.createElement('p'); q.className = 'lvc-review__quote'; q.textContent = text(r.body);
    var credit = document.createElement('span'); credit.className = 'lvc-review__credit';
    var nm = document.createElement('span'); nm.className = 'lvc-review__name'; nm.textContent = name;
    credit.appendChild(nm); cap.appendChild(q); cap.appendChild(credit);
    fig.appendChild(img); fig.appendChild(cap);
    fig.__lvr = { img: img, src: plain(photo.url), fallback: mid(photo.url) };
    return fig;
  }
  function hydrate(fig) {
    var e = fig.__lvr;
    if (!e || e.done) return;
    e.done = true;
    e.img.addEventListener('error', function onErr() {
      e.img.removeEventListener('error', onErr);
      if (e.img.getAttribute('src') !== e.fallback) e.img.src = e.fallback;
    });
    e.img.src = e.src;
  }
  function start() {
    read(1, []).then(function (reviews) {
      var byText = {}, repeated = {};
      reviews.forEach(function (r) {
        var t = r && String(r.body || '').trim().toLowerCase().replace(/\s+/g, ' ');
        if (!t) return;
        var nm = String(r.reviewer && r.reviewer.name || '').trim().toLowerCase().replace(/\s+/g, ' ');
        (byText[t] = byText[t] || []).push({ id: r.id, name: nm });
      });
      Object.keys(byText).forEach(function (t) {
        var g = byText[t], names = {};
        g.forEach(function (x) { names[x.name] = 1; });
        if (Object.keys(names).length > 1) g.forEach(function (x) { repeated[x.id] = 1; });
      });
      var seen = {}, list = [];
      reviews.forEach(function (r) {
        if (!r || seen[r.id] || repeated[r.id] || !ok(r)) return;
        seen[r.id] = 1;
        list.push(r);
      });
      list.sort(function (a, b) {
        if (style) {
          var sa = STYLE_OF[String(a.product && a.product.id || '')] === style ? 0 : 1;
          var sb = STYLE_OF[String(b.product && b.product.id || '')] === style ? 0 : 1;
          if (sa !== sb) return sa - sb;
        }
        return ts(b) - ts(a);
      });
      if (!list.length) return;
      var figs = list.map(card);
      figs.forEach(function (f) { track.appendChild(f); });
      band.setAttribute('data-lvr-count', String(track.querySelectorAll('.lvc-review').length));
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.unobserve(en.target);
            hydrate(en.target);
          });
        }, { root: track, rootMargin: '0px 64% 0px 64%', threshold: 0 });
        figs.forEach(function (f) { io.observe(f); });
      } else {
        figs.forEach(hydrate);
      }
    }).catch(function () {});
  }
  // The read starts when the band comes near the screen, so the first screen of cards isn't slowed by it.
  if ('IntersectionObserver' in window) {
    var near = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) { near.disconnect(); start(); }
    }, { rootMargin: '600px 0px' });
    near.observe(band);
  } else {
    start();
  }
})();
